let getStateData = {};

const displayMode = function (value) {
  const settings = { displayMode: value };

  return ['kw_command', settings];
};

const themeType = function (value) {
  const dark = {
    device: {
      bg: 'linear-gradient(130deg, #734FE1, #D14EE0)',
      dot: '#B8A6EE',
      border: '#E4E4E4',
      container: 'linear-gradient(130deg, #594DA0, #7D5BAA)',
    },
    keyboardButton: {
      border: '#BB0044',
      bg: '#BB0044',
      text: '#FFFFFF',
    },
    header: {
      bg: 'linear-gradient(130deg, #734FE1, #D14EE0)',
      dot: '#B8A6EE',
      text: '#ffffff',
    },
    poweredLink: {
      color: '#FFFFFF',
    },
    userInput: {
      bg: 'linear-gradient(130deg, #594DA0, #7D5BAA)',
      border: 'transparent',
      text: '#FFFFFF',
    },
    sentMessage: {
      bg: '#4e8cff',
      text: '#ffffff',
    },
    receivedMessage: {
      bg: '#eaeaea',
      text: '#222222',
    },
    inlineKeyboardButton: {
      bg: '#4e8cff',
      text: '#4e8cff',
      bgc: '#ffffff',
    },
		messageList: {
			bg: 'transparent',
		},
  };

  const light = {
    device: {
      bg: '#FCFCFC',
      dot: '#95CBFB',
      border: '#188BE4',
      container: '#FCFCFC',
    },
    keyboardButton: {
      border: '#188BE4',
      bg: '#188BE4',
      text: '#FFFFFF',
    },
    header: {
      bg: '#4e8cff',
      text: '#ffffff',
    },
    poweredLink: {
      color: '#188BE4',
    },
    userInput: {
      bg: '#f4f7f9',
      border: '#f4f7f9',
      text: '#565867',
    },
    sentMessage: {
      bg: '#4e8cff',
      text: '#ffffff',
    },
    receivedMessage: {
      bg: '#eaeaea',
      text: '#222222',
    },
    inlineKeyboardButton: {
      bg: '#4e8cff',
      text: '#4e8cff',
			bgc: '#ffffff',
    },
  };

  const color = value === 'dark' ? dark : light;

  return ['kw_color', color];
};

const buttonMode = function (value) {
  let settings = { type: value ,
   position: {
        y: 'bottom',
        x: 'right',
        offset: 25,
		 		offset_y: null,
		 		offset_x: null,
   }};

  const src=window.location.protocol+'//'+window.location.host+'/assets/';
  if(value==='avatar'){
    settings={...settings, animation: [ //имеет смысл только для avatar
        { poseName: 'stay', src:  src+'stay.gif' },
        { poseName: 'hand', src:   src+'hand.gif' },
        { poseName: 'jump', src:   src+'jump.gif' },
        { poseName: 'random', src:  'https://i.gifer.com/1V8t.gif' },
      ]
    }
  }

  if (value === 'multi') {
    // let target_copy = getStateData?.multi_channel
  
    // if(target_copy?.messengers) {
    //   target_copy.messengers["viber"] = value
    // }

    // settings={...settings, multi_channel: target_copy}
  }

  return ['kw_launcher_mode', settings];
};

const iconMode = function (value) {
  let settings = { type: value };

  if(value==="icon"){
    settings={...settings, closeIcon: 'close', openIcon: 'chat_bubble'}
  }

  else if(value==="image"){
    settings={...settings, staticImg: {
        src: 'https://www.w3schools.com/w3images/avatar2.png',
        fit: 'unset',
      }}
  }

  return ['kw_launcher', settings];
};

const avatarPose = function (value) {
  const settings = { currentPose: value };

  return ['kw_launcher_mode', settings];
};


const currentMultiChannelTitle = function (value){
  let target_copy = getStateData?.multi_channel
  
  if(target_copy?.button_title) {
    target_copy["button_title"] = value
  }

  let settings = { 'multi_channel': target_copy }
  return ['kw_command', settings]; 
}

const currentViberUrl = function (value){
  let target_copy = getStateData?.multi_channel
  
  if(target_copy?.messengers) {
    target_copy.messengers["viber"] = value
  }

  let settings = {'multi_channel': target_copy}
  return ['kw_command', settings];
}
const currentTelegramUrl = function (value){
  let target_copy = getStateData?.multi_channel
  
  if(target_copy?.messengers) {
    target_copy.messengers["telegram"] = value
  }

  let settings = {'multi_channel': target_copy}
  return ['kw_command', settings];
}
const currentFacebookUrl = function (value){
  let target_copy = getStateData?.multi_channel
  
  if(target_copy?.messengers) {
    target_copy.messengers["facebook"] = value
  }

  let settings = {'multi_channel': target_copy}
  return ['kw_command', settings];
}
const currentWhatsappUrl = function (value){
  let target_copy = getStateData?.multi_channel
  
  if(target_copy?.messengers) {
    target_copy.messengers["whatsapp"] = value
  }

  let settings = {'multi_channel': target_copy}
  return ['kw_command', settings];
}

const currentInstagramUrl = function (value){
	let target_copy = getStateData?.multi_channel

	if(target_copy?.messengers) {
		target_copy.messengers["instagram"] = value
	}

	let settings = {'multi_channel': target_copy}
	return ['kw_command', settings];
}
const avatarScale = function (value) {
  const settings = { scale: value };

  return ['kw_launcher_mode', settings];
};

const customEvent = function (value) {
  if (value.prop === 'callout') {
    const settings = {
      text: value.value,
      show: true,
      type: 'text',
    };

    return ['kw_callout', settings];
  }

  const settings = { [value.prop]: value.value };

  return ['kw_command', settings];
};

const calloutImage = function () {
  const settings = {
    show: true,
    type: 'image',
  };

  return ['kw_callout', settings];
};

const sliderMessage = function () {
  const settings = {
    show: true,
  };

  return ['kw_slider', settings];
};

const widgetLocale = function (value) {
  const settings = { language: value };

  return ['kw_language', settings];
};

const setTitle = function (value) {
  const settings = { title: value };
  return ['kw_command', settings];
};

const botId = function (value) {
  const settings = { bot_id: value };
  return ['kw_command', settings];
};

const subTitle = function (value) {
  const settings = { subtitle: value };
  return ['kw_command', settings];
};

const titleImageUrl = function (value) {
  const settings = { titleImageUrl: value };
  return ['kw_command', settings];
};

const botAvatarImageUrl = function (value) {
  const settings = { botAvatarImageUrl: value };
  return ['kw_command', settings];
};

const launcherImgSrc = function (value) {

  let settings = { type: "image" };

  settings={...settings, staticImg: {
    src: value,
    fit: 'unset',
  }}

  return ['kw_launcher', settings];
};

const timeoutMode = function (value) {
	const settings = { timeout_mode: value };

	return ['kw_command', settings];
};
const timeoutValue = function (value) {
	const settings = { timeout_value: value };

	return ['kw_command', settings];
};

const previewDemo = function (value) {
	const settings = { preview_demo: value };

	return ['kw_command', settings];
};

const recognizeUserMeta = function (value) {
	const settings = {
		recognize_user_meta: value || value === 'true'
	};

	return ['kw_command', settings];
};

const widgetButtonAnimation = function (value) {
	const settings = {
		widget_button_animation: value || value === 'true'
	};

	return ['kw_command', settings];
};


const eventList = {
    'display-mode': displayMode,
    'theme-type': themeType,
    'button-mode': buttonMode,
    'icon-mode': iconMode,
    'avatar-pose': avatarPose,
    'avatar-scale': avatarScale,
    'custom-event': customEvent,
    'callout-image': calloutImage,
    'slider-message': sliderMessage,
    'widget-locale': widgetLocale,
    'title-parameter':setTitle,
    'subtitle-parameter':subTitle,
    'title-image-url':titleImageUrl,
    'bot-avatar-url':botAvatarImageUrl,
    'bot-id':botId,
    'launcher-img-src': launcherImgSrc,
    'multi-channel-title':currentMultiChannelTitle,
    'viber-url':currentViberUrl,
    'telegram-url':currentTelegramUrl,
    'facebook-url':currentFacebookUrl,
    'whatsapp-url':currentWhatsappUrl,
    'instagram-url':currentInstagramUrl,
		'timeout-mode':timeoutMode,
		'timeout-value':timeoutValue,
		'preview-demo':previewDemo,
		'recognize-user-meta': recognizeUserMeta,
		'widget-button-animation': widgetButtonAnimation,
  };

const triggerCustomEvent = function(actionData, stateData) {
  if (!actionData) {
    return;
  }
  const domElement = document.getElementById('kwizbot_widget');
  if (!domElement) {
    return;
  }
  const getEvent = eventList[actionData.type];

  if (!getEvent) {
    return;
  }

  //save in var store state data when function fire
  getStateData = stateData;

  const [eventName, eventData] = getEvent(actionData.value);

  const eventObj = new CustomEvent(eventName, {
    detail: eventData,
  });

  domElement.dispatchEvent(eventObj);
}


const getEventData = function(type,value) {
  if (!type) {
    return;
  }
  const getEvent = eventList[type];

  if (!getEvent) {
    return;
  }

  let [command,eventData] = getEvent(value);

  if(command=='kw_color')eventData = {colors:eventData}
  if(command=='kw_launcher')eventData = {launcher:eventData}
  if(command=='kw_launcher_mode')eventData = {widgetButton:eventData}
  if(command=='kw_callout')eventData = {callout:eventData}
  if(command=='kw_multi_channel')eventData = {multi_channel:eventData}

  return eventData
}

export default {
  displayMode,
  themeType,
  botId,
  buttonMode,
  iconMode,
  avatarPose,
  avatarScale,
  customEvent,
  calloutImage,
  widgetLocale,
  setTitle,
  subTitle,
  titleImageUrl,
  botAvatarImageUrl,
  eventList,
  triggerCustomEvent,
  getEventData,
  currentMultiChannelTitle,
  currentViberUrl,
  currentTelegramUrl,
  currentFacebookUrl,
  currentWhatsappUrl,
	currentInstagramUrl,

}